export const Status = Object.freeze({
  IDLE: 'idle',
  VALID: 'valid',
  INVALID: 'invalid',
  ALREADY_EXISTS: 'already_exists',
  INTERNAL_ERROR: 'internal_error',
})
